import { TYPES } from './moviesActions';

// The initial state of the ExampleSimple
const initialState = {
    isLoading: false,
    error: '',
    movies: [],
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case TYPES.LOAD_ALL:
            return { ...state, isLoading: true, error: '' };
        case TYPES.LOAD_ALL_SUCCESS:
            return { ...state, isLoading: false, movies: action.movies };
        case TYPES.LOAD_ALL_ERROR:
            return { ...state, isLoading: false, error: action.error.message };
        default:
            return state;
    }
};

export default reducer;
